import React from 'react'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'
import BaseComponent from 'utils/BaseComponent'
import Button from 'components/Button'

import './styles.scss'

export class ConfirmationModal extends BaseComponent {

  // Delegate method should be set to _onAccept() on props when the objected is created
  // Exameple: 
  // <ConfirmationModal _onAccept={this._delegateAcceptAction.bind(this)} match={this.props.match} />

  constructor(props) {
    super(props)
    this.state = {
      buttonProps: {
        disabled: false
      },
      errors: {}
    }
    this._bind('_handleSubmit', '_cancelSendReport', '_renderMessage')
  }

  componentDidMount() {
    
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props._onAccept()
    var hideModal = this.props.hideModal
    if (hideModal == null || hideModal){
      this.context.toggleModal(false)
    }
  }

  _cancelSendReport(e){
    this.context.toggleModal(false)
  }

  _renderMessage(){
    return !!this.props.message ? (
      <div className="content">
        <br></br>
        <p>{ this.props.message }</p>
      </div>
    ) : null 
  }

  render() {
    var title = this.props.title || "Confirmar"
    var acceptLabel = this.props.acceptLabel || "Aceptar"
    var cancelLabel = this.props.cancelLabel || "Cancelar"
    return(
      <div id="ConfirmationModal" className="ConfirmationModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>{ title }</h1>
          <span className="material-icons close-button" onClick={this._cancelSendReport}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
            { this._renderMessage() }
            <div className="controls d-flex justify-content-between">
              <Button className="button"
                    size="small"
                    buttonType="danger"
                    {...this.state.buttonProps}>{ acceptLabel }</Button>
              <Button className="button"
                    size="small"
                    buttonType="primary"
                    type="button"
                    onClick={this._cancelSendReport}
                    {...this.state.buttonProps}>{cancelLabel}</Button>
            </div>
        </form>
      </div>
    )
  }
}

ConfirmationModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    state: state.clientDetail.get('state').toObject(),
    location: state.clientDetail.get('location').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal)



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/index.js